/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `MapObject.ts` file.
 ******/
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

import { MapObject } from "./MapObject";

import { MapObjectRadius } from "./MapObjectRadius";
import { Project } from "./Project";

export type geometry = "point" | "polygon" | "lineString";
export type iconAnchor =
    "center" | "left" | "right" | "top" | "bottom" | "top_left" | "top_right" | "bottom_left" | "bottom_right";

export const geometryValues = { point: 0, polygon: 1, lineString: 2 };
export const iconAnchorValues = {
    center: 0,
    left: 1,
    right: 2,
    top: 3,
    bottom: 4,
    top_left: 5,
    top_right: 6,
    bottom_left: 7,
    bottom_right: 8,
};

export abstract class MapObjectModel {
    id: number;
    color: string | null;
    coordinates: any;
    createdAt: Dayjs;
    geometry: geometry;
    icon: string | null;
    iconAnchor: iconAnchor;
    iconUnits: string | null;
    iconWidth: number | null;
    mappableId: number | null;
    mappableType: string | null;
    opacity: number;
    outline: string | null;
    projectId: number;
    updatedAt: Dayjs;
    uuid: string;
    archived: boolean | null;
    project: Project | null | undefined;
    radiuses: MapObjectRadius[] | undefined;
    _destroy: boolean | undefined;

    constructor(
        id: number,
        color: string | null,
        coordinates: any,
        createdAt: Dayjs,
        geometry: geometry,
        icon: string | null,
        iconAnchor: iconAnchor,
        iconUnits: string | null,
        iconWidth: number | null,
        mappableId: number | null,
        mappableType: string | null,
        opacity: number,
        outline: string | null,
        projectId: number,
        updatedAt: Dayjs,
        uuid: string,
        archived: boolean | null,
        project: Project | null | undefined,
        radiuses: MapObjectRadius[] | undefined
    ) {
        this.id = id;
        this.color = color;
        this.coordinates = coordinates;
        this.createdAt = createdAt;
        this.geometry = geometry;
        this.icon = icon;
        this.iconAnchor = iconAnchor;
        this.iconUnits = iconUnits;
        this.iconWidth = iconWidth;
        this.mappableId = mappableId;
        this.mappableType = mappableType;
        this.opacity = opacity;
        this.outline = outline;
        this.projectId = projectId;
        this.updatedAt = updatedAt;
        this.uuid = uuid;
        this.archived = archived;
        this.project = project;
        this.radiuses = radiuses;
    }

    static fromApiObject(json: any, timezone: string): MapObject {
        const newObject = new MapObject(
            json["id"],
            json["color"],
            json["coordinates"],
            dayjs(json["created_at"]).tz(timezone),
            json["geometry"],
            json["icon"],
            json["icon_anchor"],
            json["icon_units"],
            json["icon_width"],
            json["mappable_id"],
            json["mappable_type"],
            json["opacity"],
            json["outline"],
            json["project_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["uuid"],
            json["archived"],
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone),
            json["radiuses"]?.map((item: any) => MapObjectRadius.fromApiObject(item, timezone))
        );

        return newObject;
    }

    toApiObject(): any {
        return {
            id: this.id,
            color: this.color,
            coordinates: this.coordinates,
            created_at: this.createdAt,
            geometry: this.geometry,
            icon: this.icon,
            icon_anchor: this.iconAnchor,
            icon_units: this.iconUnits,
            icon_width: this.iconWidth,
            mappable_id: this.mappableId,
            mappable_type: this.mappableType,
            opacity: this.opacity,
            outline: this.outline,
            project_id: this.projectId,
            updated_at: this.updatedAt,
            uuid: this.uuid,
            radiuses_attributes: this.radiuses?.map((item) => item.toApiObject()),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): MapObject {
        const clone = Object.create(this) as MapObject;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
